module.exports = __webpack_public_path__ + "static/media/8.dca9e541.svg";